import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Accounting Layout Wrapper
 * This component acts as a pure container for accounting sub-routes.
 * The internal FINANCE card and sidebar have been completely removed.
 * Navigation is now handled exclusively by the global sidebar.
 */
const Accounting = () => {
    return (
        <div id="accounting-container" style={{ width: '100%', minHeight: '100%' }}>
            <Outlet />
        </div>
    );
};

export default Accounting;
